import { API_BASE ,axiosApi} from "../config"
import {
  GeneralReturnInterface,
  GetQuotesReturnInterface,
  QuoteInterfaceWithCaptcha,
  UpdateQuoteInterface
} from "../types"


export const createQuoteRequest = async (body:QuoteInterfaceWithCaptcha): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/createQuoteRequest`,body)).data
}


export const getQuotes = async (): Promise<GetQuotesReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getQuotes`)).data
}



export const updateQuote = async (body:UpdateQuoteInterface): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/updateQuote`,body)).data
}
